module.exports = __webpack_public_path__ + "static/package-1-bg-d7c26ff331658aebfec748c82661de55.png";